import React, { Component } from "react";
import Project from "./project.jpg";
export default class ProjectsImg extends Component {
  render() {
    return <img src={Project} alt="" />;
  }
}
